import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';
import {
  ACTA_HALLAZGO,
  MONITOREOS_ESPECTACULARES,
  MONITOREOS_VISITAS_VERIFICACION
} from 'constants/tipoMonitoreos';

const SeccionUbicacion = ({ form, tipoMon, tipoActa }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="entidad">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ entidad: target.checked });
              }}>
              Entidad
            </Checkbox>
          </Form.Item>
          {tipoMon === MONITOREOS_ESPECTACULARES && tipoActa !== ACTA_HALLAZGO && (
            <Form.Item name="numJuntaLocal">
              <Checkbox
                className="check-campos"
                onChange={({ target }) => {
                  form.setFieldsValue({ numJuntaLocal: target.checked });
                }}>
                No. Junta Local
              </Checkbox>
            </Form.Item>
          )}
          <Form.Item name="municipio">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ municipio: target.checked });
              }}>
              Municipio
            </Checkbox>
          </Form.Item>
          <Form.Item name="calle">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ calle: target.checked });
              }}>
              Calle
            </Checkbox>
          </Form.Item>
          <Form.Item name="numero">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ numero: target.checked });
              }}>
              Número exterior
            </Checkbox>
          </Form.Item>
          <Form.Item name="colonia">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ colonia: target.checked });
              }}>
              Colonia
            </Checkbox>
          </Form.Item>
          <Form.Item name="codigoPostal">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ codigoPostal: target.checked });
              }}>
              Código postal
            </Checkbox>
          </Form.Item>
          <Form.Item name="entreCalle">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ entreCalle: target.checked });
              }}>
              Entre calle
            </Checkbox>
          </Form.Item>
          <Form.Item name="yCalle">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ yCalle: target.checked });
              }}>
              Y calle
            </Checkbox>
          </Form.Item>
          <Form.Item name="referencias">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ referencias: target.checked });
              }}>
              Referencias del lugar
            </Checkbox>
          </Form.Item>
          {(tipoMon === MONITOREOS_ESPECTACULARES && tipoActa === ACTA_HALLAZGO) ||
          tipoMon === MONITOREOS_VISITAS_VERIFICACION ? (
            <>
              <Form.Item name="latitud">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ latitud: target.checked });
                  }}>
                  Latitud
                </Checkbox>
              </Form.Item>
              <Form.Item name="longitud">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ longitud: target.checked });
                  }}>
                  Longitud
                </Checkbox>
              </Form.Item>
            </>
          ) : (
            ''
          )}
        </div>
      </Form>
    </div>
  );
};

export default SeccionUbicacion;

SeccionUbicacion.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoMon: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired
};
